export const getFilters = s => s.news.get('filters')?.toJS();
export const getNews = s => s.news.get('news').toJS();
export const getNewsLoading = s => s.news.get('newsLoading');
